import type { ReactNode } from "react";
import { PublicShell } from "@/components/layout/PublicShell";

/** Privacy and Terms: one long-read column on the design system. */
export function LegalPage({
  eyebrow,
  title,
  intro,
  children,
}: {
  eyebrow: string;
  title: string;
  intro: string;
  children: ReactNode;
}) {
  return (
    <PublicShell>
      <div className="ds-container ds-container--narrow">
        <header className="ds-page-head">
          <p className="ds-eyebrow ds-eyebrow--teal">{eyebrow}</p>
          <h1 className="ds-display-1">{title}</h1>
          <p className="ds-lead">{intro}</p>
          <dl className="ds-facts" style={{ margin: 0 }}>
            <span><dt style={{ display: "inline" }}>Last updated </dt><dd style={{ display: "inline", margin: 0 }}><b>25 August 2026</b></dd></span>
            <span><dt style={{ display: "inline" }}>Effective from </dt><dd style={{ display: "inline", margin: 0 }}><b>25 August 2026</b></dd></span>
          </dl>
        </header>
        <article className="ds-panel ds-legal">{children}</article>
      </div>
    </PublicShell>
  );
}

export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="ds-legal__section">
      <h2 className="ds-display-2" style={{ fontSize: 26 }}>{title}</h2>
      <div className="ds-legal__body">{children}</div>
    </section>
  );
}

export function LegalSubsection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="ds-legal__sub">
      <h3 className="ds-title" style={{ fontSize: 17 }}>{title}</h3>
      <div className="ds-legal__body">{children}</div>
    </section>
  );
}
